import React from 'react';

import styles from './styles.module.css';

const SeparationLine = () => (
  <div className={styles.line} />
);

export default SeparationLine;
